<!-- 全人发展卡 - 生命之轮 -->
<template>
  <div class="game-1">
    <nf-card borderInnerSize="0" round=".2rem">
      <div class="game-1-box">
        <div class="game-1-box-list">
          <div class="game-1-box-list-wheel">{{ gameInfo.cateName }}</div>
          <Swipe ref="swipeRef" :show-indicators="false" :loop="false">
            <swipe-item style="height: auto">
              <div class="game-1-box-list-wheel-box-right">
                <div class="game-1-box-list-wheel-box-right-item">
                  <div
                    class="game-1-box-list-wheel-box-right-item-step"
                    style="width: 1.6rem"
                  ></div>

                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      width: 100%;
                      font-weight: bold;
                    "
                  >
                    <div>1分</div>
                    <div>10分</div>
                  </div>
                </div>

                <template v-for="(item, index) in gameList">
                  <div
                    class="game-1-box-list-wheel-box-right-item"
                    :key="index"
                  >
                    <div class="game-1-box-list-wheel-box-right-item-check">
                      {{ item.name }}
                    </div>
                    <Slider
                      :button-size="12"
                      class="game-1-box-list-wheel-box-right-item-step"
                      v-model="item.value"
                      :step="1"
                      :max="10"
                      :min="0"
                      buttonSize="20"
                      :active-color="item.color"
                    />
                    <div class="game-1-box-list-wheel-box-right-item-value">
                      {{ item.value }}
                    </div>
                  </div>
                </template>

                <NfButton
                  color="rgb(172,185,233)"
                  round=".5rem"
                  style="margin-top: 0.2rem"
                  class="card-select-btns-btn"
                  @click.native="changeSwiper(1)"
                  >查看轮盘</NfButton
                >
              </div>
            </swipe-item>
            <SwipeItem style="height: auto">
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                  align-items: center;
                  height: 100%;
                "
              >
                <div
                  class="game-1-box-list-wheel-box-left"
                  style="
                    pointer-events: none;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 100%;
                  "
                >
                  <MorebarEchart
                    width="380px"
                    height="380px"
                    @click.stop
                    :distData="gameList"
                  />
                </div>
                <NfButton
                  color="rgb(172,185,233)"
                  round=".5rem"
                  @click.native="changeSwiper(0)"
                  >查看打分</NfButton
                >
              </div>
            </SwipeItem>
          </Swipe>
          <div class="game-1-box-list-divider"></div>
          <!-- 确认选择 -->
          <NfButton
            :disabled="!isConfirm"
            color="rgb(172,185,233)"
            round=".5rem"
            style="margin-top: 0.2rem; padding: 0 0.2rem"
            class="card-select-btns-btn"
            @click.native="confirmHandle"
            >确认选择</NfButton
          >
        </div>
      </div>
    </nf-card>
  </div>
</template>

<script>
import NfCard from "@/components/game-ui/NfCard.vue";
import CardReverseAndConfirm from "@/components/game-comm/CardReverseAndConfirm.vue";
import {
  Swipe,
  SwipeItem,
  Image as VanImage,
  Grid,
  GridItem,
  Checkbox,
  Slider,
} from "vant";
import NfButton from "@/components/game-ui/NfButton.vue";
import { MorebarEchart } from "@/components/echarts";
import cookie from "@utils/store/cookie";

export default {
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          name: "",
          roleTab: 0,
        };
      },
    },
    cardList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    gameInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    userInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    form: {},
    sizeType: {
      type: String,
      default: "big",
    },
    gameStatus: {
      type: Number,
      default: 1,
    },
    frontSelectCardList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    game3List: {
      type: Array,
      default: () => {
        return [];
      },
    },
    game3Lock: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    console.log("game3 mounted");
  },

  activated() {
    console.log("game3 activated");
  },
  data() {
    return {
      selectActiveCardList: [],
      selectCardList: [],
      firstLock: [],
    };
  },
  components: {
    NfCard,
    NfButton,
    Swipe,
    SwipeItem,
    VanImage,
    Grid,
    GridItem,
    MorebarEchart,
    Checkbox,
    Slider,
    CardReverseAndConfirm,
  },
  computed: {
    formValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.form = this.val;
        this.$emit("update:value", {
          ...val,
        });
      },
    },
    isConfirm() {
      // 所有选项的分数都不为0
      return this.gameList.every((item) => {
        return item.value != 0;
      });
    },
    gameList: {
      get() {
        return this.game3List;
      },
      set(val) {
        this.$emit("update:game3List", val);
      },
    },
  },
  watch: {
    // 监听列表，如果其中一项的value不等于0，则将其checked设置为true
    gameList: {
      handler(val) {
        console.log(this.formValue);
        // 清空
        if (this.formValue.playerCardList[this.formValue.roleTab]) {
          this.formValue.playerCardList[this.formValue.roleTab].splice(
            0,
            this.formValue.playerCardList[this.formValue.roleTab].length
          );
        }
        this.gameList.map((item, index) => {
          const data = {
            ...item,
            ...this.cardList[index],
            name: (this.cardList[index] || {}).cardName || "",
            color:
              (this.cardList[index] || {}).colour || this.gameList[index].color,
          };
          item.name = (this.cardList[index] || {}).cardName || "";
          item.color =
            (this.cardList[index] || {}).colour || this.gameList[index].color;
          // console.log(data, "datada", (this.cardList[index] || {}).colour)
          (this.formValue.playerCardList[this.formValue.roleTab] || []).push(
            data
          );
        });

        // 缓存当前用户的选择
        // this.cacheSelectCard();
        // 判断val中是否有不为0的value
        // console.log("isConfirm", 222);

        const isConfirm = val.some((item) => {
          return item.value != 0;
        });
        if (isConfirm && !this.game3Lock) {
          this.cacheSelectCard();
        }
        // console.log("isConfirm", isConfirm);
      },
      deep: true,
      immediate: true,
    },
    "value.roleTab": {
      handler(val, oldVal) {
        this.selectCardList = this.formValue.playerCardList[val];
      },
      deep: true,
    },
    // 为了让它触发深度监听，临时解决方案
    "value.playerCardList": {
      handler(val) {
        this.selectActiveCardList = val[this.formValue.roleTab];
      },
      deep: true,
      immediate: true,
    },
    // 监听卡牌列表的变化，同步到gameList中
    cardList: {
      handler(list) {
        if (list.length > 0) {
          // 裁剪gameList的长度
          // console.log("触发剪裁", list.length, this.gameList.length);
          this.gameList.splice(list.length, this.gameList.length - list.length);
          // 让gameList中的value
          this.changeGameList();
        }
      },
      deep: true,
      immediate: true,
    },
    frontSelectCardList: {
      handler(val) {
        if (this.gameInfo.visibleType == "wheel" && val.length > 0) {
          console.log("frontSelectCardList", val);
          this.changeGameList();
        }
      },
      deep: true,
      // immediate: true,
    },
  },
  methods: {
    // 确认选择
    confirmHandle() {
      if (!this.isConfirm) {
        this.$dialog.message("请为所有类型打上分数哦");
        return;
      }
      if (this.formValue.successSaveUser.includes(this.formValue.roleTab)) {
        this.$dialog.message("该玩家已记录");
        return;
      }
      let data = this.formValue.playerCardList[this.formValue.roleTab];

      // console.log("data", data)
      // return

      // const data = this.formValue.map((item) => {
      //   return {
      //     cardId: item.id,
      //     cardName: item.cardName,
      //     cateId: item.cateId,
      //     cateName: item.cateName,
      //     createTime: item.createTime,
      //     secondCateId: item.secondCateId,
      //     secondCateName: item.secondCateName,
      //     roundId: this.gameInfo.gameRoundId,
      //     gameId: this.gameInfo.gameId,
      //     playerId: this.playerId,
      //     playerName: this.playerName,
      //     userId: this.userInfo.uid,
      //   };
      // });

      // this.formValue.playerCardList[this.formValue.roleTab].map((item)=>{

      // })

      data = data.map((item) => {
        item.score = item.value;
        return {
          // ...item.data,
          userId: this.userInfo.uid,
          roundId: this.gameInfo.gameRoundId,
          gameId: this.gameInfo.gameId,
          playerId: this.formValue.roleTab,
          playerName: this.formValue.roleName,

          score: item.value,
          cardId: item.id,
          cardName: item.cardName,
          cateId: item.cateId,
          cateName: item.cateName,
          createTime: item.createTime,
          secondCateId: item.secondCateId,
          secondCateName: item.secondCateName,
          //value: item.data.value,
        };
      });
      // console.log("data", data)
      // return
      this.$emit("confirm", data);
    },
    changeGameList() {
      // this.gameList.splice(this.cardList.length, this.gameList.length - this.cardList.length);
      // 开始判断是否同步
      const config = this.gameInfo;
      // 通过roundNum从大到小排序
      let frontSelectCardList = [...this.frontSelectCardList];
      frontSelectCardList.sort((a, b) => {
        return b.roundNum - a.roundNum;
      });
    },
    // 放回卡牌
    putCardHandle(index) {
      this.gameList[index].value = 0;
    },
    checkHandle(item) {
      if (!item.checked) {
        item.value = 5;
      } else {
        item.value = 0;
      }
    },
    changeSwiper(index) {
      this.$refs.swipeRef.swipeTo(index);
    },
    // 缓存当前用户的选择，gameList每次变化触发
    cacheSelectCard() {
      console.log("开始缓存");
      // gameId + roundId + uid + roleId
      const key = `${this.gameInfo.gameId}_${this.gameInfo.gameRoundId}_${this.userInfo.uid}_${this.formValue.roleTab}`;
      // const storeData = localStorage.getItem(key);
      // 改成cookie，有效期为一天
      // const storeData = cookie.get(key);
      const storeData = JSON.parse(localStorage.getItem(key)) || [];
      if (storeData) {
        localStorage.removeItem(key);
        // cookie.remove(key);
      }
      // localStorage.setItem(key, JSON.stringify(this.gameList));
      // 改成cookie，有效期为一天
      const date = new Date();
      date.setDate(date.getDate() + 1);
      // cookie.set(key, JSON.stringify(this.gameList), date);
      localStorage.setItem(key, JSON.stringify(this.gameList));
    },
    // tab页切换
    tabChangeHandle(val, oldVal) {
      console.log("页面切换处理");
      if (this.formValue.roleTab != 0) {
        // 获取当前用户的选择
        const key = `${this.gameInfo.gameId}_${this.gameInfo.gameRoundId}_${this.userInfo.uid}_${this.formValue.roleTab}`;
        console.log("key", key);

        const data = JSON.parse(cookie.get(key)) || [];

        console.log("走缓存", data);
        if (data.length > 0) {
          // 遍历gameList，将value设置为data中的value
          this.gameList.map((item, index) => {
            const findIndex = data.findIndex((subitem) => {
              return subitem.name == item.name;
            });
            if (findIndex > -1) {
              item.value = data[findIndex].value;
            } else {
              item.value = 0;
            }
          });
        } else {
          // 否则全部归零
          this.gameList.map((item, index) => {
            item.value = 0;
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.game-1 {
  color: #666;
  &-box {
    &-title {
      text-align: center;
    }

    &-list {
      ::v-deep .van-grid-item__content {
        padding: 0.1rem;
      }

      &-divider {
        // 虚线
        border-top: 1px dashed #666;
        margin: 0.3rem 0;
      }

      &-select {
        &-btns {
          display: flex;
          justify-content: space-between;
          margin-top: 0.2rem;
          &-btn {
            margin: 0 0.2rem;
          }
        }
      }

      &-wheel {
        &-box {
          display: flex;

          &-left {
            padding: 0 0.2rem;
            display: flex;
            align-items: center;
          }

          &-right {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 0 0.2rem;

            font-size: 0.2rem;
            width: 100%;
            &-item {
              display: flex;
              align-items: center;
              height: 0.6rem;
              &-check {
                flex-shrink: 0;
                margin-right: 0.4rem;
                font-size: 0.23rem;
              }
              &-value {
                font-size: 0.25rem;
                // padding: 0 0.05rem;
                padding-left: 0.3rem;
              }
            }
          }
        }
      }
    }

    &-step {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 0.2rem;

      &-left {
      }
      &-right {
        flex: 1;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        &-item {
          display: flex;
          // align-items: center;
          justify-content: space-between;
          margin: 0.1rem 0;
          &-text {
            font-size: 0.25rem;
          }
          &-icon {
          }
        }
      }
    }
  }
}
</style>
